module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._v("\n  特别说明：本公司在此声明，您通过本软件参加的商业活动，与Apple Inc.无关。\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f60a4250"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/specialInstructions.vue
// module id = 243
// module chunks = 1